exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".card[data-v-b2719c8c]{font-size:13px;box-sizing:border-box;padding:20px;background:#e2e2e2;background:linear-gradient(0deg,#e2e2e2,#f5f5f5 48%,#fdfdfd)}span[data-v-b2719c8c]{font-size:40px}p[data-v-b2719c8c]{margin-top:0}.text[data-v-b2719c8c]{text-align:justify;color:#686868;font-size:12px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b2719c8c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/Card.vue
// module id = 1171
// module chunks = 0